import './presentation.component.pug'
import './presentation.component.scss'

import { Swiper, Autoplay, Mousewheel } from 'swiper'

Swiper.use([Autoplay, Mousewheel])

document.querySelectorAll('.presentation').forEach((root) => {
  if (window.innerWidth > 768) {
    function navigationHandler(root, swiperInstance) {
      root
        .querySelectorAll('.presentation-navigation-item')
        .forEach((elem) => elem.classList.remove('active-nav-item'))
      const activeIdx = swiperInstance.activeIndex
      const activeItem = root.querySelectorAll('.presentation-navigation-item')[
        activeIdx
      ]
      activeItem.classList.add('active-nav-item')
    }

    const swiperElement = root.querySelector('.swiper-container')

    const swiper = new Swiper(swiperElement, {
      speed: 800,
      init: false,
      autoplay: {
        delay: 5000
      },

      edgeSwipeDetection: 'prevent',
      mousewheel: {
        forceToAxis: true
      },
      on: {
        init(swiperInstance) {
          navigationHandler(root, swiperInstance)
        },
        activeIndexChange(swiperInstance) {
          navigationHandler(root, swiperInstance)
        }
      }
    })
    swiper.autoplay.stop()
    import(
      /* webpackChunkName: "interactiveFabric" */ '../../application/interactiveFabric'
    ).then(({ ScrollMagic }) => {
      const controller = new ScrollMagic.Controller()
      const scene = new ScrollMagic.Scene({
        duration: '150%',
        offset: 0,
        triggerElement: root
      }).addTo(controller)

      scene.on('enter', async function () {
        swiper.init()
        if (process.env.NODE_ENV === 'production') {
          swiper.autoplay.start()
        }
      })
      scene.on('leave', async function () {
        swiper.autoplay.stop()
      })

      root
        .querySelectorAll('.presentation-navigation-item')
        .forEach((button, index) => {
          button.addEventListener('click', function () {
            swiper.slideTo(index)
          })
        })
    })
  }
})
